import { render, staticRenderFns } from "./TicketStoreItem.vue?vue&type=template&id=04f84bc0&"
import script from "./TicketStoreItem.vue?vue&type=script&lang=js&"
export * from "./TicketStoreItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports